/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {message} from 'antd'
import Select from 'react-select'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import $ from 'jquery'
import REPORT_RETAIL from '../../Component/BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Loader from '../loaders/loader'

class CompleteProductDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      wareHousesname: [],
      docType: [],
      errorForm: '',
      showTable: false,
      list: [],
      preRecordInfo: {},
      urlQuery: '',
      providers: [],
      providerValue: '',
      selectedOption: [],
      wareType: [],
      fromDate: '',
      toDate: '',
      modalDelete: false,
      fromManual: '',
      toManual: '',
      printInfo: [],
      printFrom: '',
      printTo: '',
      buttonClicked: false,
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: '',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'راننده',
          value: 'drivername',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تعداد کل',
          value: 'productCount',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'دریافت شده',
          value: 'receivedCount',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'جزییات',
          value: 'receivedCount',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      Drivers: [],
      driverId: '',
      tablePageNumber: 1
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  get componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_RECIEVED_MASTER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            tablePageNumber: this.state.pageNumber,
            tablePageSize: this.state.pageSize,
            loading: false,
            list: response.data.object.result,
            errorForm: '',
            lengthList: response.data.object.countAll,
            printFrom: this.state.fromDate == '' ? ' - ' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
            printTo: this.state.toDate == '' ? ' - ' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
            buttonClicked: true
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            listWareHouse: [],
            lengthList: 0,
            loading: false
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        alert(JSON.stringify(error))
      })
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    let planDateMin = this.state.fromDate
    let planDateMax = this.state.toDate
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (driverId !== '') {
      filter.driverId = driverId
    }

    if (planDateMin !== '') {
      filter.planDateMin = planDateMin
    }
    if (planDateMax !== '') {
      filter.planDateMax = planDateMax
    }

    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  changeDropDown(data) {
    this.setState({
      listWareHouse: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_RECIEVED_MASTER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            printInfo: response.data.object.result,
            lengthList: response.data.object.countAll
          })
        } else {
          this.setState({
            printInfo: []
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_RECIEVED_MASTER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['manualRegisterDate'] = jMoment(excelReport[i]['manualRegisterDate']).format('jYY/jMM/jDD')
            excelReport[i]['registerDate'] = jMoment(excelReport[i]['registerDate']).format('jYY/jMM/jDD')
            if (excelReport[i]['internal']) {
              excelReport[i]['internal'] = 'هست'
            } else {
              excelReport[i]['internal'] = 'نیست'
            }

            if (excelReport[i]['input']) {
              excelReport[i]['input'] = 'وارده'
            } else {
              excelReport[i]['input'] = 'صادره'
            }
          }
          this._export.save(this.state.excelReport)
        }
      })
  }

  render() {
    const {wareHousesname, selectedOption} = this.state
    let {pageNumber, pageSize} = this.state
    var preWarehouseDocIdNum = sessionStorage.getItem('preWarehouseDocId')
    let name = cookie.load('name')
    let columns = ['ردیف', 'رساننده', 'کل', 'دریافت شده']

    let excelColumns = [{title: 'نام سند', value: 'name'}, {title: 'نوع سند', value: 'in'}]

    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش کالاهای تکمیل شده رانندگان"
              headerColSpan={4}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={1}
              rightColSpan={2}
              centerColSpan={1}
              centerSection={''}
              rightSection={'تاریخ از ' + this.state.printFrom + ' تا ' + this.state.printTo}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.driver.name}</td>
                  <td>{item.productCount}</td>
                  <td>{item.receivedCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            ref={(exporter) => {
              this._export = exporter
            }}
            dir="rtl"
            fileName="گزارش کالاهای تکمیل شده رانندگان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'driver'}
                field={'driver.name'}
                title={'راننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'driver'}
                field={'productCount'}
                title={'کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'driver'}
                field={'receivedCount'}
                title={'دریافت شده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>توزیع</li>
            <li>کالاهای تکمیل شده رانندگان</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/addPreRecord'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  fromId="from"
                  toId="to"
                  defaulValue
                />

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.list.map((item, index) => (
                    <tr key={index}>
                      <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                      <td>{item.driver.name}</td>
                      <td>{item.productCount}</td>
                      <td>{item.receivedCount}</td>
                      <td>
                        <Link
                          target="_blank"
                          to={
                            '/report/driver/complete/ProductDriver/details/' +
                            item.driver.personId +
                            `/${this.state.fromDate}/${this.state.toDate}/${item.driver.name}`
                          }
                        >
                          <img src={require('../../image/details.svg')} />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthList}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CompleteProductDrivers
